import React from 'react'
// import { Link } from 'react-router-dom'


function BlockChainServiceDetails() {
    return (
        <div>
            <div className="services-details-area default-padding">
                <div className="cotnainer">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="site-heading text-center">
                                <h4 className="sub-title">Performance Marketing</h4>
                                <h1 className="title">Smart PPC Campaigns for Smarter Business Growth</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="services-details-items">
                        <div className="row">
                            <div className="col-xl-12 services-single-content">
                                <div className="thumb mb-50">
                                    <img className="w-100" src="static/img/blockchain/21.webp" alt="Thumb" title='Application Development' />
                                </div>
                                <p>
                                    Microcode Software has years of experience running high-value ads through pay-per-click (PPC) advertising for a variety of business purposes. If you want your ads to not only deliver results but also target the right audience at the right time, we have a results-oriented approach to advertising! There is enough marketing available for the entire industry, so let us help you achieve measurable data for your business and maximize your ROI.

                                </p>
                                <h2>Our Commerce & Consumer Experience Solutions</h2>
                                <p>
                                    <strong>Commerce Media & Shoppable Content:</strong> We help brands turn passive viewers into active buyers by creating shoppable videos, live-streaming transactions or interactive advertising. We combine entertainment with e-commerce in a way that produces measurable ROI and an entertaining experience that can lead to conversions.
                                </p>
                                <p>
                                    <strong> Social Commerce Enablement:</strong> We create powerful social commerce strategies on platforms like Instagram, Facebook and YouTube, utilizing in-app shopping integrations and influencer-based campaigns to convert social channels into high-performing sales funnels. This complements our core PPC management services that drive sales and audience growth.
                                </p>
                                <p><strong>Retail Media Network Advertising:</strong>  We have a partnership with the largest retail networks, such as Amazon and Walmart, to utilize their first-party data for advertising campaigns. We leverage consumer data by tapping into high-intent consumers at the point of sale.
                                </p>
                                <p><strong>Privacy-First Marketing Strategies:</strong>  With third-party cookies on the decline, we are focusing on gathering first-party data through loyalty programs, surveys, and interactive content. Consumer trust is important for brand loyalty, so we are able to provide valuable experiences with a higher level of consumer trust.
                                </p>
                                <p><strong>Omnichannel Experience Integration:</strong>  We create customer journeys across physical and digital experiences, such as click-and-collect, AR-enabled virtual try-on, and unified customer experience profiles, to eliminate consumer friction and provide consistency and connected experiences across the board.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-content bg-gray default-padding">
                <div className="container">
                    <div className="about-style-one-items">
                        <div className="row align-items-center">

                            <div className="col-xl-7 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                                <div className="about-style-one-info">
                                    <div className="content">
                                        <h2 className="title">
                                            Measurement & Optimization Services
                                        </h2>
                                        <p>
                                            Maximize campaigns based on real-time insights and advanced tracking—not data abuse, for smarter decisions and a better return on investment. Accelerate growth with trusted data, without sacrificing user privacy.
                                        </p>
                                        <a class="btn btn-md circle btn-gradient animation mb-20 mb-lg-0" href="/contact" data-discover="true">Contact Us</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <div className="thumb-style-one">
                                    <img src="static/img/blockchain/2.webp" alt="Img Not Found" title='Application Development' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='services-details-area default-padding'>
                <div className='container'>
                    <div className="process-style-one-items mt-50">
                        <div className="choose-us-one-thumb">
                            <div className="content">
                                <div className="left-info">
                                    <h2 className="title">
                                        Clicks That Count, Results That Scale
                                    </h2>
                                </div>
                                <div className="process-style-one">
                                    <div className="process-style-one-item">
                                        <span>01</span>
                                        <h4>Planning & Strategy</h4>
                                        <p>
                                            Define your goals, audience, keywords, and budget before launching your PPC campaign.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>02</span>
                                        <h4>Campaign Setup</h4>
                                        <p>
                                            Create ad groups, write compelling ads, and link them to optimized landing pages.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>03</span>
                                        <h4>Monitoring & Optimization</h4>
                                        <p>
                                            Track results, test variations, and adjust bids and keywords to improve performance.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BlockChainServiceDetails
